import BottomNavigation from './BottomNavigation';
export default BottomNavigation;



// WEBPACK FOOTER //
// ./src/js/BottomNavigations/index.js